import React from "react";
import missing from "../../assets/images/missing.png";

import "./style.scss";

function EmployeeCard({data, className}) {
  const { title, acf: { image, phone, role } } = data;

  return (
    <div className={className ? "EmployeeCard " + className : "EmployeeCard"}>
      <img className="EmployeeCard__image" src={image ? image.sizes.medium : missing} alt={image.alt} />
      <p className="EmployeeCard__name">{title.rendered}</p>
      <p className="EmployeeCard__role">{role}</p>
      <p className="EmployeeCard__phone">{phone}</p>
    </div>
  );
}

export default EmployeeCard;
